<script setup>
import { ref } from 'vue';
import FormButton from '../../components/Atoms/FormButton.vue';
import IconBase from '../../components/icon/IconBase.vue';
import IconPlay from '../../components/icon/IconPlay.vue';
import IconBook from '../../components/icon/IconBook.vue';
import IconCalendarPlus from '../../components/icon/IconCalendarPlus.vue';
import DemoVideoModal from '../../components/modals/DemoVideoModal.vue';
import PageHeader from '@/components/ui/PageHeader.vue';
import { openCalendly } from '@/utils'

const demoModal = ref()

const showDemoModal = () => {
	demoModal.value.show()
}

</script>

<template>
	<div class="container detail-shell px-4">
		<main>
			<PageHeader title="OTT Apps" subtitle="Launch branded streaming apps across mobile and TV platforms." />
			<article class="flex flex-col pt-8 md:pt-12 lg:pt-20 xl:pt-28">
				<h2 class="text-surface-text-2 text-center text-xl font-medium xl:mb-2">White-Labeled OTT Apps</h2>
				<h3 class="text-surface-8 text-sm text-center">White-labeled mobile and TV apps for your brand on iOS, Android,
					Roku, Android TV, and Apple TV.</h3>
				<p class="text-surface-8 text-sm text-center leading-6 text-balance">Built-in billing, email automation, and
					advanced features, all in one platform.</p>
				<p class="text-surface-8 text-sm text-center leading-6 mb-6 text-balance">Book a meeting with us today to get
					started!</p>
				<div class="flex w-full max-w-sm flex-col items-stretch justify-center gap-2 mx-auto mb-6 sm:items-center">
					<FormButton
						href="https://docs.castr.com/en/articles/5483773-introducing-castr-ott-create-your-own-branded-streaming-platform"
						target="_blank" class="flex w-full justify-center gap-x-2 sm:w-64" type="secondary">
						<icon-base>
							<icon-book />
						</icon-base>
						How OTT Apps work
					</FormButton>
					<FormButton @click="showDemoModal" class="flex w-full justify-center gap-x-2 sm:w-64" type="secondary">
						<icon-base>
							<icon-play />
						</icon-base>
						OTT Apps demo
					</FormButton>
					<FormButton
						@click="openCalendly()"
						class="flex w-full justify-center gap-x-2 sm:w-64">
						<icon-base classIcon="inline -mt-1" iconColor="transparent">
							<icon-calendar-plus />
						</icon-base>
						Book a meeting
					</FormButton>
				</div>
			</article>
		</main>
		<demo-video-modal ref="demoModal" videoid="cm4gtj1il1uys124hh7g8q43x" />
	</div>
</template>

<style></style>
